import TransactionHistoryList from '@/app/pages/history/components/TransactionHistoryList/index'

export default function getHistoryComponent(component) {
  switch (component?.type) {
    case 'list':
      return <TransactionHistoryList data={component} />
    default:
      return null
  }
}
